<template>
    <div>
        <div v-if="simple" class="flex justify-between items-center">
            <div @click="routePrevious" v-if="page > 1" class="cursor-pointer p-2">
                <ChevronLeftIcon class="h-4 w-4" aria-hidden="true" />
            </div>
            <span class="text-xs text-gray-700 px-4">
                Página {{ page }}
            </span>
            <div @click="routeNext" v-if="(count / limit) > page" class="cursor-pointer p-2">
                <ChevronRightIcon class="h-4 w-4" aria-hidden="true" />
            </div>
        </div>

        <div class="flex justify-between" v-else>
            <span class="relative z-0 inline-flex shadow-sm rounded-md">
                <button @click="routePrevious" v-if="page > 1" type="button"
                    class="relative  inline-flex items-center px-2 py-2 rounded-l-md border border-gray-200 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500">
                    <span class="sr-only">Previous</span>
                    <ChevronLeftIcon class="h-5 w-5" aria-hidden="true" />
                </button>

                <span v-if="totalPages() > 1"
                    class="relative inline-flex items-center px-2 py-2 border border-gray-200 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500">
                    {{ page }}
                </span>

                <button @click="routeNext" v-if="(count / limit) > page" type="button" class="-ml-px relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-200 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500">
                    <ChevronRightIcon class="h-5 w-5" aria-hidden="true" />
                </button>
                
            </span>

            <div v-if="totalPages() > 1">
                <select class="defaultInput" @change="getPage($event.target.value)">
                    <option v-for="limit in totalPages()" :value="limit" :selected="limit == page">{{ limit }}</option>
                </select>
            </div>

        </div>
    </div>
</template>




<script>
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/vue/24/solid'

export default {
    name: "ListControl",
    props: {
        count: {
            type: [Number, String],
            default: 1,
        },
        page: {
            type: [Number, String],
            default: 1,
        },
        limit: {
            type: [Number, String],
            default: 15,
        },
        query: {
            type: Object,
            default: () => ({}),
        },
        simple: {
            type: Boolean,
            default: false,
        },
        onChange: Function,

    },
    components: {
        ChevronLeftIcon,
        ChevronRightIcon,
    },
    methods: {
        getPage(index) {
            const pageIndex = parseInt(index);
            if (pageIndex === parseInt(this.page)) return;

            this.updatePage(pageIndex);
        },
        totalPages() {
            const total = Math.ceil(this.count / this.limit);
            return total > 50 ? 50 : total;
        },
        routeNext() {
            const nextPage = parseInt(this.page) + 1;
            if (nextPage <= this.totalPages()) {
                this.updatePage(nextPage);
            }
        },
        routePrevious() {
            const prevPage = parseInt(this.page) - 1;

            if (prevPage >= 1) {
                this.updatePage(prevPage);
            }
        },
        updatePage(newPage) {
            if (this.onChange) {
                this.onChange(newPage);
                return;
            }
            this.$router.push({ path: this.$route.path, query: { ...this.$route.query, page: newPage } });
            this.$emit('change', newPage);
        },
        queryToString() {
            let query = { ...this.$route.query };
            delete query.page;  // Remove a página atual da string de consulta

            return Object.keys(query)
                .filter(key => query[key] !== null)
                .map(key => `${key}=${query[key]}`)
                .join('&');
        },
    },
    mounted() {

        // Impede multiplos reloads nos componentes
        if (Object.keys(this.$route.query).length > 0 && this.$route.query.page === undefined) {

            // Existe pelo menos um parâmetro na URL, mas não o 'page'
            this.$router.replace({
                path: this.$route.path,
                query: {
                    ...this.$route.query ,
                    page: 1  // Adiciona 'page=1' à query existente
                }
            });
        }

    }
}
</script>
